import { filter } from 'rxjs/operators';
import { select } from '@ngrx/store';
import { AutoFocusPrefocusEvent } from './../../../assets/plugins/formvalidation/src/js/plugins/AutoFocus';
import { element } from 'protractor';

import * as _ from 'lodash';
export interface TitleList {
    colunName: string;
    titleName: string;
}

import {
    Component,
    OnInit,
    Input,
    ViewChild,
    Output,
    EventEmitter,
    ChangeDetectorRef,
    AfterContentInit,
    ElementRef,
    AfterViewInit,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationCustomList } from 'src/app/models/configurationCustomList';
import { Router } from '@angular/router';
import { ModalConfig } from 'src/app/models/modalConfig';
import { MatSelect } from '@angular/material/select';
import { MatFormField } from '@angular/material/form-field';
import { NotificationsService } from 'angular2-notifications';
import { AppConfig } from 'src/app/core/_config/app.config';
import { DialogCustomComponent } from '../dialog-custom/dialog-custom.component';
import { MatDialog } from '@angular/material/dialog';
import { Page } from 'src/app/models/page';

@Component({
    selector: 'custom-list',
    templateUrl: './custom-list.component.html',
    styleUrls: ['./custom-list.component.scss'],
})
export class CustomListComponent implements AfterViewInit {
    @Input() cols: string[];
    @Input() titles: string[];
    @Input() data: {}[];
    @Input() config: ConfigurationCustomList;
    @Input() startLineSelected: boolean;

    @Output() resSelectLine = new EventEmitter();
    @Output() outSelectedLine = new EventEmitter();
    @Output() reloadTable = new EventEmitter();

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatSort;
    @ViewChild('matSelect', { static: false }) matSelect: MatSelect;
    @ViewChild('matFormField', { static: false }) matFormField: MatFormField;

    tableDataSrc: any;

    queryParams: object;

    selectedLines: string[] = new Array();

    copy: any;

    name: string;
    color: string;
    pageIndex;

    constructor(
        private cdRef: ChangeDetectorRef,
        private translate: TranslateService,
        private router: Router,
        private notificationsService: NotificationsService,
        private configSystem: AppConfig,
        public dialog: MatDialog,
    ) {
        this.copy = _.cloneDeep(this.data);
    }

    ngAfterViewInit(): void {
        if (this.config.sortableType) {
            this.sort.sort({ id: this.cols[2], start: this.config.sortableType } as MatSortable);
        } else {
            this.sort.sort({ id: this.cols[2], start: 'asc' } as MatSortable);
        }

        this.tableDataSrc = new MatTableDataSource(this.data);
        this.tableDataSrc.sort = this.sort;
        this.tableDataSrc.paginator = this.paginator;

        if (!this.config.getSelected) {
            this.config.getSelected = false;
        }

        if (this.config.typeField == null) {
            this.config.typeField = [];
        }

        if (this.config.actionLine == null) {
            this.config.actionLine = {
                status: false,
            };
        }

        this.cdRef.detectChanges();
    }

    editLine(element, ev) {
        element[this.config.selectConfig.varResponse] = 0;

        if (ev == undefined) {
            ev = {
                target: {
                    classList: ['exeption'],
                },
            };
        }  

        this.onActionLine(element, ev);
    }

    ngOnChanges(changes: any) {

        if (changes['config'] && this.config && !this.config.columnWidths) {
            this.config.columnWidths = {};
        }

        this.cdRef.detectChanges();

        if (changes.startLineSelected && changes.startLineSelected.currentValue) {
            this.getLines('select');
        }
    }

    onSearchInput(ev) {
        const searchTarget = ev.target.value;

        this.tableDataSrc.filter = searchTarget.trim().toLowerCase();
    }

    onActionLine(element, ev) {
        const sourceElement = ev.srcElement;
        if (sourceElement.textContent.toLowerCase().trim() === 'delete') return;

        if (this.config.actionLine.status) {
            switch (this.config.actionLine.typeActionLine) {
                case 'redirect':
                    if (this.config.queryParams.active) {
                        this.queryParams = this.createQueryParams(element);
                    } else {
                        this.queryParams = { id: element.id };
                    }

                    this.router.navigate([`${this.config.actionLine.urlRedirect}`, this.queryParams]);

                    break;

                case 'select':
                    switch (ev.target.classList[0]) {
                        case 'mat-select-placeholder':
                        case 'mat-select-arrow':
                        case 'mat-form-field-infix':
                        case 'mat-form-field-wrapper':
                        case 'mat-select-arrow-wrapper':
                        case 'btnUndo':
                        case 'iconInfo':
                            break;

                        default:
                            if (
                                element[this.config.actionLine.paramSelected[0]] ===
                                this.config.actionLine.paramSelected[1]
                            ) {
                                let oldElement = element.lineStatus.name;

                                element[this.config.actionLine.paramSelected[0]] = oldElement;
                            } else {
                                if (element.error !== 0 && element.solution === 0) {
                                    switch (element.lineStatus.name) {
                                        case 'Succeeded':
                                        case 'Accounted':
                                            this.notificationsService.warn('', `item ja processado.`);

                                            break;

                                        default:
                                            this.notificationsService.warn(
                                                '',
                                                `Selecione uma Solução para o item ${element.numberLine}.`,
                                            );
                                            break;
                                    }
                                } else {
                                    element[this.config.actionLine.paramSelected[0]] =
                                        this.config.actionLine.paramSelected[1];
                                }
                            }
                            break;
                    }
                    break;
            }
        }
    }

    returnTitleName(i) {
        if (this.titles && this.titles.length > 0) {
            let titleName = this.titles[i];
            if (!titleName) return '';

            return titleName;
        } else {
            return '';
        }
    }
    translateOptionSelect(item) {
        let result = `CUSTOMLIST.${this.config.tableTranslate}.VALUES${
            item[this.config.selectConfig.nameProperties[0]]
        } ${this.config.selectConfig.simbolDetach} ${item[this.config.selectConfig.nameProperties[1]]}`;
        return result;
    }

    onSelected(element, optionSelected, optionSelectedName) {
        element[this.config.selectConfig.varResponse] = optionSelected;

        element.dataFile.audit.solution.name = optionSelectedName;

        let emmiter: ModalConfig = {
            element: element,
            status: true,
            typeSolution: optionSelected,
        };

        this.resSelectLine.emit(emmiter);
    }

    createQueryParams(element) {
        var result = {};

        for (let param in this.config.queryParams.params) {
            let objectInPosition = this.config.queryParams.params[param];

            result[objectInPosition] = element[objectInPosition];
        }

        return result;
    }

    getLines(type: string) {
        var result;

        switch (type) {
            case 'select':
                result = _.filter(
                    this.data,
                    (x) => x[this.config.actionLine.paramSelected[0]] === this.config.actionLine.paramSelected[1],
                );

                break;

            default:
                break;
        }

        this.outSelectedLine.emit(result);
    }

    actionRedirectIcon(element) {
        window.open(
            `${this.configSystem.urlOldAfs}AccountsReceiving/AccountsReceiving/?billetId=${element.dataReceiving[0].billetIdExternal}`,
            '_blank',
        );
    }

    actionDeleteDuplicate(element: any) {
        if (this.config.duplicate) {
            this.resSelectLine.emit(element);
        }
    }
    
    onRefreshLine(element: any) {
        this.resSelectLine.emit({ action: 'refresh', element});
    }

    openDialog(param: string[]): void {
        const dialogRef = this.dialog.open(DialogCustomComponent, {
            width: '500px',
            data: param,
        });

        dialogRef.afterClosed().subscribe((res) => {
            this.color = res;
        });
    }

    changePage(ev) {
        let returnPaginator = {
            previousPageIndex: ev.previousPageIndex,
            pageSize: ev.pageSize,
            pageIndex: ev.pageIndex,
            length: ev.length,
            tableName: this.config.tableName,
        };

        this.reloadTable.emit(returnPaginator);
    }
}
